import React from "react";

const TikTokVideo = ({ }) => {
    return (
        <div>
            <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@cloudpedia.ai/video/7213902394143509806" data-video-id="7213902394143509806" style="max-width: 605px;min-width: 325px;" >
                <section> <a target="_blank" title="@cloudpedia.ai" href="https://www.tiktok.com/@cloudpedia.ai?refer=embed">@cloudpedia.ai</a>
                    S1E10 - Career opportunities in Cloud Computing <a title="cloudcomputing" target="_blank" href="https://www.tiktok.com/tag/cloudcomputing?refer=embed">#cloudcomputing</a>
                    <a title="cloudcareer" target="_blank" href="https://www.tiktok.com/tag/cloudcareer?refer=embed">#cloudcareer</a>
                    <a target="_blank" title="♬ original sound - TechieInYou - CloudPedia.AI" href="https://www.tiktok.com/music/original-sound-TechieInYou-7213902478239746858?refer=embed">♬ original sound - TechieInYou - CloudPedia.AI</a>
                </section>
            </blockquote>
            <script async src="https://www.tiktok.com/embed.js"></script>
        </div>
    )
};

export default TikTokVideo;